module.exports = __webpack_public_path__ + "../static/img/fail.26da7a0e.png";